import { Inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { CompanyInformation } from '@pulpo/pulpo-models';
import ApiService from './api.service.abstract';
import { APP_CONFIG } from '@pulpo/app-config';
import { Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class CompanyInformationService extends ApiService<CompanyInformation> {
  constructor(
    @Inject(APP_CONFIG) environment: any,
    protected http: HttpClient
  ) {
    super(environment, http, 'api/company-information');
  }

  getByCompanyId(companyId: number | string): Observable<CompanyInformation[]> {
    return this.http.get<CompanyInformation[]>(
      `${this.url}/${this.endpoint}/company/${companyId}`
    );
  }

  getByProvider(provider: string): Observable<CompanyInformation[]> {
    return this.http.get<CompanyInformation[]>(
      `${this.url}/${this.endpoint}/provider/${provider}`
    );
  }
}
